export default __webpack_public_path__ + "static/media/RELATORIO_GERAL.40893d47.svg";